import { useMatch } from '@solidjs/router';

const urlMatches = (url: string) => {
    const matches = useMatch(() => url);
    return Boolean(matches());
};

export default urlMatches;